import { memo, useCallback } from "react";

import { PlainWidgetDecoration } from "@/lib/gql/__generated__/graphql";

/**
 * WidgetDecoration: 装飾選択 UI 等で使う Snack ウィジェット装飾プレビュー。
 *
 * z-index 順: Fill(z-0 背面) → 画像 wrapper(z-10) → Line(z-20 前面)。
 * 旧実装は画像が z-20、Fill が z 未指定で画像に隠れていたバグ状態だったため、
 * ゲスト SnackWidgetCard.astro と同じ層順に修正している。
 */

type Props = {
	thumbnail: string;
	primaryColor: string;
	plainWidgetDecoration: PlainWidgetDecoration;
};

export const WidgetDecoration = memo(({ thumbnail, primaryColor, plainWidgetDecoration }: Props) => {
	const Decoration = useCallback(() => {
		if (plainWidgetDecoration === PlainWidgetDecoration.Fill)
			return (
				<div className="absolute left-2 top-2 z-0 h-48 w-full rounded" style={{ background: primaryColor }} />
			);

		if (plainWidgetDecoration === PlainWidgetDecoration.Line)
			return (
				<div
					className="pointer-events-none absolute left-2 top-2 z-20 h-48 w-full rounded border-2"
					style={{ borderColor: primaryColor }}
				/>
			);

		return null;
	}, [primaryColor, plainWidgetDecoration]);

	return (
		<div className="relative">
			<Decoration />
			<div className="relative z-10 h-48 w-full overflow-hidden rounded">
				<img src={thumbnail} className="h-full w-full object-cover" alt="" />
			</div>
		</div>
	);
});
